// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"d2942cc7","160":"b278f0f3","230":"026cf6da","251":"fad9b164","313":"2b0cb947","445":"9f758e5d","450":"7f377848","461":"db5b1bf3","816":"a856807f","925":"b26f1596","928":"e97c1585","987":"d581c690"}[chunkId] + ".chunk.js";
};